import { render, staticRenderFns } from "./IconGroup.vue?vue&type=template&id=026e3d70&scoped=true&"
import script from "./IconGroup.vue?vue&type=script&lang=js&"
export * from "./IconGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e3d70",
  null
  
)

export default component.exports